import { Location } from 'react-router-dom';
import { DOCS_V2_BASE_ROUTE } from '../api/documentationApi';

export interface DocumentationLocationState {
  documentationReturnPath?: string;
}

export function createDocumentationLocationState(
  location: Location,
): DocumentationLocationState {
  return {
    documentationReturnPath: getDocumentationLocationPath(location),
  };
}

export function getDocumentationReturnPath(
  locationState: unknown,
  currentLocation: Location,
): string | undefined {
  if (!isDocumentationLocationState(locationState)) {
    return undefined;
  }

  const documentationReturnPath = locationState.documentationReturnPath;
  const currentDocumentationPath = getDocumentationLocationPath(currentLocation);

  if (
    !isDocumentationAppPath(documentationReturnPath) ||
    documentationReturnPath === currentDocumentationPath
  ) {
    return undefined;
  }

  return documentationReturnPath;
}

function getDocumentationLocationPath(location: Location): string {
  return `${location.pathname}${location.search}${location.hash}`;
}

function isDocumentationAppPath(path: string): boolean {
  return (
    path === DOCS_V2_BASE_ROUTE ||
    path.startsWith(`${DOCS_V2_BASE_ROUTE}/`)
  );
}

function isDocumentationLocationState(
  locationState: unknown,
): locationState is { documentationReturnPath: string } {
  if (!locationState || typeof locationState !== 'object') {
    return false;
  }

  if (!('documentationReturnPath' in locationState)) {
    return false;
  }

  return typeof locationState.documentationReturnPath === 'string';
}
